var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5033 22.9512C20.1442 22.9512 20.7589 23.2146 21.2121 23.6834C21.6653 24.1522 21.9199 24.7881 21.9199 25.4512C21.9199 24.7881 22.1745 24.1522 22.6277 23.6834C23.081 23.2146 23.6956 22.9512 24.3366 22.9512C23.6956 22.9512 23.081 22.6878 22.6277 22.2189C22.1745 21.7501 21.9199 21.1142 21.9199 20.4512C21.9199 21.1142 21.6653 21.7501 21.2121 22.2189C20.7589 22.6878 20.1442 22.9512 19.5033 22.9512ZM19.5033 7.95117C20.1442 7.95117 20.7589 8.21456 21.2121 8.6834C21.6653 9.15225 21.9199 9.78813 21.9199 10.4512C21.9199 9.78813 22.1745 9.15225 22.6277 8.6834C23.081 8.21456 23.6956 7.95117 24.3366 7.95117C23.6956 7.95117 23.081 7.68778 22.6277 7.21894C22.1745 6.7501 21.9199 6.11421 21.9199 5.45117C21.9199 6.11421 21.6653 6.7501 21.2121 7.21894C20.7589 7.68778 20.1442 7.95117 19.5033 7.95117ZM11.0449 22.9512C11.0449 20.962 11.8088 19.0544 13.1684 17.6479C14.528 16.2413 16.3721 15.4512 18.2949 15.4512C16.3721 15.4512 14.528 14.661 13.1684 13.2545C11.8088 11.8479 11.0449 9.9403 11.0449 7.95117C11.0449 9.9403 10.2811 11.8479 8.92145 13.2545C7.56181 14.661 5.71774 15.4512 3.79492 15.4512C5.71774 15.4512 7.56181 16.2413 8.92145 17.6479C10.2811 19.0544 11.0449 20.962 11.0449 22.9512Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    fill: "white",
    transform: "translate(0.169922 0.451172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.92f67b45025ff1088626cff783b1eb80.svg";
export { ForwardRef as ReactComponent };